var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    _vm._b(
      {
        attrs: {
          "invalid-feedback": _vm.invalidFeedback,
          "label-for": _vm.formControlId,
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm.label
                  ? [
                      _vm._v(
                        "\n            " + _vm._s(_vm.label) + "\n            "
                      ),
                      _c("csp-form-tooltip", {
                        attrs: { tooltip: _vm.tooltip },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "b-form-group",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c("b-form-input", {
        class: [
          _vm.hideArrows ? "hide-arrows" : "",
          _vm.potentiallyRequired ? "border-yellow" : "",
        ],
        attrs: {
          id: _vm.formControlId,
          autocomplete: _vm.autocomplete,
          disabled: _vm.isReadOnlyProperty,
          max: _vm.max,
          maxlength: _vm.maxlength,
          min: _vm.min,
          name: _vm.formControlId,
          placeholder: _vm.placeholder,
          required: _vm.isRequiredProperty,
          state: _vm.validationState,
          step: _vm.step,
          type: _vm.type,
          value: _vm.data[_vm.property],
        },
        on: {
          blur: function ($event) {
            return _vm.$emit("blur")
          },
          change: function ($event) {
            return _vm.$emit("change")
          },
          input: _vm.handleInput,
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("formGroupInputEnter")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }